import styled, { css } from 'styled-components';

export const TableStyled = styled.table`
  ${({ theme }) => css`
    width: 100%;
    border-collapse: collapse;
    border: 1px solid ${theme.colors.grey[300]};
  `}
`;

export const ThStyled = styled.th`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.grey[1000]};
    background-color: ${theme.colors.grey[200]};
    padding-top: ${theme.spacings[450]};
    padding-bottom: ${theme.spacings[450]};
    font-size: ${theme.fontSizes[300]};
    border: 1px solid ${theme.colors.grey[300]};
    padding-left: ${theme.spacings[500]};
    text-align: left;
    font-family: ${theme.fontFamilies.graphik};
    @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
      padding-left: ${theme.spacings[400]};
    }
  `}
`;

export const TdStyled = styled.td`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.grey[300]};
    padding-left: ${theme.spacings[500]};
    padding-top: ${theme.spacings[450]};
    padding-bottom: ${theme.spacings[450]};
    font-size: ${theme.fontSizes[300]};
    color: ${theme.colors.grey[1000]};
    vertical-align: middle;
    font-family: ${theme.fontFamilies.graphik};
    @media only screen and (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
      padding-left: ${theme.spacings[400]};
    }
  `}
`;
